import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";

const IntensiveHolidayAdhoc = () => {
  return (
    <>
      <Helmet>
        <title>
          Intensive, Holiday and Ad-hoc Programs | Public Speaking Academy
        </title>
        <meta
          name="description"
          content="The 2-day intensive public speaking programmes, with syllabi tailored for both children and adults, are helmed by our very own World Champion of Public Speaking, Darren Tay. Learn effective communication skills to speak with flair and confidence!"
        />
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex justify-between mx-3">
            <div>Intensive, Holiday and Ad-hoc Programs</div>
            <div>
              Home / Courses and Programs / Intensive, Holiday and Ad-hoc
              Programs
            </div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row pt-5 space-y-10 lg:space-y-0 lg:space-x-5">
            <div class="w-full lg:w-2/3">
              <div>
                <h1 class="font-primary text-3xl font-bold text-primary uppercase">
                  Holiday / Intensive Public-Speaking Masterclasses (for
                  Children & Adults)
                </h1>
                <div>
                  <p class="pt-5 pb-2 font-text text-lg">
                    Are you looking for an intensive, school holiday public
                    speaking masterclass programme? Whether you are a student or
                    an adult / working professional – we present to you
                    Singapore’s only World Champion S’Peak Performance
                    Masterclass for both students and adults!
                  </p>
                  <p class="pt-2 pb-5 font-text text-lg">
                    The 2-day intensive public speaking programme, with syllabi
                    tailored for both children and adults, is helmed by our very
                    own World Champion of Public Speaking and Master Trainer,
                    Darren Tay. Learn effective communication skills from the
                    World Champion of Public Speaking, ranging from overcoming
                    stage anxiety, preparing for that dreaded National Oral
                    Examinations (for students) or delivering that powerful
                    business presentation.
                  </p>
                  <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 space-x-0 lg:space-x-5 items-center justify-between py-5">
                    <div className="w-full lg:w-1/2">
                      <img src="/images/speak-performance-1.jpg" alt="" />
                    </div>
                    <div className="w-full lg:w-1/2">
                      <img
                        src="/images/holiday-intensive-public-speaking masterclasses.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="py-5">
                    <h2 class="font-primary text-xl font-bold text-primary">
                      Meet our World Champion of Public Speaking for the 2-Day
                      Masterclass!
                    </h2>
                    <p class="pt-2 pb-5 font-text text-lg">
                      Essential soft skills such as public speaking and
                      interpersonal communication skills have become
                      increasingly important and highly sought after both in
                      schools and the modern workplace – from Direct School
                      Admission to Scholarship interviews, multimedia classroom
                      presentations to oral examinations and even leadership
                      roles / day-to-day interaction among students or
                      colleagues. Everyone wants to stand out and shine both in
                      school and at the workplace – the individuals who are able
                      to secure that promotion or lead the project are both
                      intelligent and more importantly, eloquent – possessing
                      the ability to cogently and persuasively deliver his/her
                      ideas to classmates, colleagues, employers, clients or
                      investors.
                    </p>
                    <p class="pt-2 pb-5 font-text text-lg">
                      Here at Public Speaking Academy, we believe that the
                      opportunity to pick up effective public speaking and
                      communication skills should be open to all. Based on our
                      primary research, many students and adults lack either
                      stage confidence, self-esteem or stage competencies, which
                      impairs the effectiveness of their communication skills.
                      Worse still, this can even create a vicious cycle of
                      students and adults reinforcing their self-limiting belief
                      that they were just born without the ‘gift of the gab’ or
                      that “Nature” trumps “Nurture”, therefore perpetuating the
                      deficiency of self-confidence!
                    </p>
                    <p class="pt-2 pb-5 font-text text-lg">
                      Instead, our team of professional public speaking trainers
                      strongly believe that essential soft skills such as public
                      speaking and interpersonal communication skills can
                      absolutely be nurtured and taught effectively. These
                      timeless communication skills and the clear benefits of
                      equipping your child or yourself with it will continue to
                      empower and transform your life immediately in your
                      workplace or your future path.
                    </p>
                  </div>
                  <div className="py-5">
                    <h2 class="font-primary text-xl font-bold text-primary">
                      What You Can Expect from the S’Peak Performance
                      Masterclasses
                    </h2>
                    <ul className="py-2 px-5 list-disc list-outside">
                      <li className="text-lg font-text pb-2">
                        <strong className="italic">
                          Personal “World Champion” Touch
                        </strong>{" "}
                        – our Master Trainer and World Champion of Public
                        Speaking 2016 will personally conduct the S’Peak
                        Performance Programme – sharing World-Class guidance,
                        and tried and tested public speaking and
                        confidence-boosting strategies
                      </li>
                      <li className="text-lg font-text pb-2">
                        <strong className="italic">
                          UNIQUE and FRESH Teaching Approach
                        </strong>{" "}
                        – creative and refreshing methods of monitoring progress
                        during the programme e.g. through the usage of video
                        recording to track performance and progress or using a
                        3-tier evaluation to facilitate improved learning curve
                      </li>
                      <li className="text-lg font-text pb-2">
                        <strong className="italic">
                          Flexible and Applicable Public Speaking Frameworks
                        </strong>{" "}
                        – be exposed to extensive public speaking frameworks
                        which are applicable in various contexts (from
                        one-on-one settings to effective business presentations)
                      </li>
                      <li className="text-lg font-text pb-2">
                        <strong className="italic">
                          Safe, Conducive and Constructive Environment
                        </strong>{" "}
                        – our students are provided with a safe, conducive and
                        constructive platform to practise their public speaking
                        skills and to make as many mistakes as possible and
                        learn from one another – this is a valuable opportunity
                        for our students to speak up before a group and hone the
                        practical aspects
                      </li>
                    </ul>
                    <p class="pt-2 pb-5 font-text text-lg">
                      From basic communication skills (e.g. body language, hand
                      gestures) to specific skills (e.g. interviews,
                      interpersonal communication), the S’Peak Performance
                      Programme is the public speaking training programme of
                      choice to ensure your continuous development as a powerful
                      public presenter or a confident communicator. Join us now!
                    </p>
                  </div>

                  <div className="mx-auto">
                    <div className="flex flex-col justify-center items-center mx-3 my-5 space-y-5 md:flex-row md:space-y-0 md:space-x-3">
                      <NavLink
                        to="/presentation-skills-training-course-by-world-champion"
                        className="px-3 py-2 text-center text-white bg-gray-800 hover:bg-btnColor w-60 uppercase rounded"
                      >
                        For Adult Learners
                      </NavLink>
                      <NavLink
                        to="/school-holiday-public-speaking-program-for-children"
                        className=" px-3 py-2 text-center text-white bg-gray-800 hover:bg-btnColor w-60 uppercase rounded"
                      >
                        For Students / Children
                      </NavLink>
                    </div>
                  </div>

                  <div className="bg-slate-50 p-2 md:p-10 ">
                    <div className=" mb-10">
                      <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                        END OF COURSE DETAILS
                      </h1>
                      <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                        Quick Tips
                      </h1>
                    </div>

                    <div
                      tabIndex={0}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        💬 How to Build Confidence in Adult Introverts for
                        Presentations
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Introverts can be powerful presenters—when they learn
                          to harness calm, focused communication.
                        </p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Reframe the purpose
                          </p>
                          <p className="font-text">
                            Shift focus to how your speech is going to benefit
                            the audience, not performing for them or for them to
                            judge you.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Prepare and practice deeply
                          </p>
                          <p className="font-text">
                            Introverts tend to thrive with structure. Rehearse
                            until the content feels second nature. Internalize
                            with sign-posting (…after delivering the
                            ‘challenges’, now comes the ‘solutions’…)
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Use strengths like clarity and thoughtfulness
                          </p>
                          <p className="font-text">
                            You don’t have to be flashy. A quiet, well-paced
                            delivery can be just as compelling.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Start with low-pressure settings
                          </p>
                          <p className="font-text">
                            Try small team meetings, Zoom calls, or one-on-one
                            presentations first.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Learn breathing and grounding techniques
                          </p>
                          <p className="font-text">
                            Simple tools like pursed-lips breathing (Feeling the
                            cool air up the nose when inhaling, and slowly
                            exhaling with pursed lips) or pausing with sustained
                            eye contact before you speak can keep nerves in
                            check.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      tabIndex={1}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        🧠 How to Improve Presentation Skills
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Presentation skills refer to your ability to clearly,
                          confidently, and effectively share information with an
                          audience. Engagement techniques form a core aspect of
                          presentation skills.
                        </p>
                        <p className="py-1">
                          Whether you’re in a meeting, on stage, or online, here
                          are simple ways to level up:
                        </p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Structure your message
                          </p>
                          <p className="font-text">
                            Use a clear beginning, middle, and end. Start with a
                            hook, dive into key points, and wrap with a strong
                            takeaway. Clarity is King, Delivery is Queen.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Practice aloud
                          </p>
                          <p className="font-text">
                            Rehearsing out loud helps build fluency and uncover
                            weak spots. Record yourself or present to a friend.
                            You may receive feedback from your viewers
                            thereafter.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Mind your body language
                          </p>
                          <p className="font-text">
                            Stand tall, make eye contact, and use open gestures.
                            Your body speaks even when your mouth doesn’t. Other
                            aspects of body language include stage positioning,
                            facial expressions and body language leakages.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Speak with intention
                          </p>
                          <p className="font-text">
                            Pace yourself, pause for impact, and emphasize key
                            words. Don’t rush—clarity matters more than speed.
                            Speaking with intention also helps with reducing the
                            use of pause fillers.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Get feedback
                          </p>
                          <p className="font-text">
                            Ask a trusted colleague or coach for honest,
                            constructive input.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      tabIndex={2}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        😰 How to Overcome Fear of Public Speaking
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Fear of public speaking is common—it’s often rooted in
                          a fear of judgment or making mistakes.
                        </p>
                        <p className="py-1">To manage it effectively:</p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Prepare thoroughly
                          </p>
                          <p className="font-text">
                            Knowing your material well builds confidence. Use
                            sign-posts throughout the speech to internalize its
                            structure well.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Visualize success
                          </p>
                          <p className="font-text">
                            Shift your focus from negativity to picturing
                            yourself speaking calmly and clearly. Mental
                            rehearsal matters.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Start small
                          </p>
                          <p className="font-text">
                            Speak up in small meetings or practice with friends
                            before tackling bigger stages.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Focus on your audience
                          </p>
                          <p className="font-text">
                            “Big Baby Pivot” – treating your audience as a “big
                            baby” that requires your full attention, instead of
                            focusing on yourself, shift it to how you can help
                            or inform others.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Breathe and pause
                          </p>
                          <p className="font-text">
                            Take deep breaths (inhale while feeling the coolness
                            of the air, and exhale with pursed lips). Pausing
                            helps you think and eases nerves. Pause with
                            sustained eye contact to enhance the impact of your
                            pauses.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      tabIndex={3}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        👪 Is Public Speaking Also Good for Kids?
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Yes—public speaking is one of the most valuable life
                          skills a child can build.
                        </p>
                        <p className="py-1">Here’s why:</p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Builds confidence
                          </p>
                          <p className="font-text">
                            Kids learn to speak up, reduce fear of rejection/
                            objection, even in unfamiliar settings.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Improves communication
                          </p>
                          <p className="font-text">
                            They become better listeners and more thoughtful
                            speakers.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Sharpens thinking
                          </p>
                          <p className="font-text">
                            Organizing ideas and expressing opinions boosts
                            critical thinking.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Encourages leadership
                          </p>
                          <p className="font-text">
                            Strong speakers often become natural leaders in
                            school and beyond.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Prepares them for interviews and exams
                          </p>
                          <p className="font-text">
                            Verbal communication is a key part of academic/
                            future career success.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      tabIndex={4}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        📅 Best School Holiday Programs for Kids in Singapore
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Looking for enriching activities during school breaks?
                        </p>
                        <p className="py-1">Here’s what to consider:</p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Skill-building focus
                          </p>
                          <p className="font-text">
                            Choose programs that develop holistic life skills
                            like communication in various settings (impromptu
                            speech, storytelling, interview, oral exam, class
                            presentation).
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Progressive learning and exposure
                          </p>
                          <p className="font-text">
                            Children thrive in settings where they won’t get
                            thrown into the deep end of the water; breaking into
                            smaller groups to present before culminating in the
                            bigger audience will be more receptive.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Engaging curriculum
                          </p>
                          <p className="font-text">
                            Look for activities that balance fun with learning.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Safe and supportive environment
                          </p>
                          <p className="font-text">
                            Make sure instructors are trained and experienced
                            with children.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Tangible takeaways
                          </p>
                          <p className="font-text">
                            Kids should walk away more confident, capable, and
                            inspired.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      tabIndex={5}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        🎓 DSA Interview Tips for Shy Children
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Shy children can still shine in Direct School
                          Admission (DSA) interviews with the right preparation
                          and emotional support.
                        </p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Practice common questions
                          </p>
                          <p className="font-text">
                            Rehearse responding to common questions, like “Tell
                            me about yourself” or “Why this school?”
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Build familiarity with mock interviews
                          </p>
                          <p className="font-text">
                            Use a quiet space, dress up, and simulate the real
                            environment.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Focus on strengths and real stories
                          </p>
                          <p className="font-text">
                            Help your child prepare a few achievements (or
                            challenges they have overcome) they feel proud to
                            share.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Teach calming strategies
                          </p>
                          <p className="font-text">
                            Breathing exercises can ease anxiety before the
                            interview (Feeling the cool air up the nose when
                            inhaling, and slowly exhaling with pursed lips).
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Reframe “shyness” as thoughtfulness
                          </p>
                          <p className="font-text">
                            Let your child know that quiet examination of the
                            situation is a mark of confidence —and schools
                            notice that too.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      tabIndex={6}
                      className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                    >
                      <div className="text-xl font-medium collapse-title text-btnColor">
                        🎤 How to Get Better at Impromptu Speaking
                      </div>
                      <div className="collapse-content">
                        <p className="p-1">
                          Impromptu speaking means thinking on your feet and
                          expressing ideas without much prep time—it’s a
                          valuable life and work skill.
                        </p>
                        <p className="py-1">Here’s how to improve:</p>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            1. Use a simple structure
                          </p>
                          <p className="font-text">
                            Stick to Point – Explanation – Example – Link
                            (reiterate the point). It keeps your answer clear
                            even under pressure.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            2. Pause before you speak
                          </p>
                          <p className="font-text">
                            Take a breath to gather your thoughts (Inhale by
                            feeling the cool air up the nose, and exhale with
                            pursed lips). A short pause shows confidence, not
                            hesitation.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            3. Practice with prompts
                          </p>
                          <p className="font-text">
                            Use random topics or questions and give yourself 30
                            seconds to respond. It builds fluency by
                            internalizing the impromptu frameworks (PEEL).
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            4. Focus on one main idea
                          </p>
                          <p className="font-text">
                            Don’t try to say everything—pick one key point and
                            support it well.
                          </p>
                        </div>
                        <div className="py-1">
                          <p className="font-bold font-primary">
                            5. Stay calm under pressure
                          </p>
                          <p className="font-text">
                            Mistakes are okay. The goal is to sound natural by
                            not interrupting the speech flow, not perfect.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="hidden lg:inline lg:w-1/3 border border-dashed rounded-lg pt-5 px-5 mb-10">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default IntensiveHolidayAdhoc;
